import { render, staticRenderFns } from "./sales-detail-dialog.vue?vue&type=template&id=38c84cec&scoped=true&"
import script from "./sales-detail-dialog.vue?vue&type=script&lang=js&"
export * from "./sales-detail-dialog.vue?vue&type=script&lang=js&"
import style0 from "./sales-detail-dialog.vue?vue&type=style&index=0&id=38c84cec&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c84cec",
  null
  
)

export default component.exports